import { t } from 'i18next'
import * as Yup from 'yup'
import { FormField } from 'src/enums/Form'
import {
  Comunidad,
  Orden,
  OrganoJudicial,
  PartidoJudicial,
  Provincia
} from 'src/interfaces/Catalog'

export type OrganoOrigenFormValues = {
  [FormField.ORGANO_ORIGEN_COMUNIDAD_AUTONOMA]: Comunidad | null
  [FormField.ORGANO_ORIGEN_PROVINCIA]: Provincia | null
  [FormField.ORGANO_ORIGEN_PARTIDO_JUDICIAL]: PartidoJudicial | null
  [FormField.ORGANO_ORIGEN_ORGANO_JUDICIAL]: OrganoJudicial | null
  [FormField.ORGANO_ORIGEN_ORDEN_JUDICIAL]: Orden | null
}

export const OrganoOrigenFormInitialvalues: OrganoOrigenFormValues = {
  [FormField.ORGANO_ORIGEN_COMUNIDAD_AUTONOMA]: null,
  [FormField.ORGANO_ORIGEN_PROVINCIA]: null,
  [FormField.ORGANO_ORIGEN_PARTIDO_JUDICIAL]: null,
  [FormField.ORGANO_ORIGEN_ORGANO_JUDICIAL]: null,
  [FormField.ORGANO_ORIGEN_ORDEN_JUDICIAL]: null
}

export const OrganoOrigenFormValidations = (): any => {
  return Yup.object().shape({
    [FormField.ORGANO_ORIGEN_COMUNIDAD_AUTONOMA]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_ORIGEN_PROVINCIA]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_ORIGEN_PARTIDO_JUDICIAL]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_ORIGEN_ORGANO_JUDICIAL]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_ORIGEN_ORDEN_JUDICIAL]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default'))
  })
}
